import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, enableNetwork } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDgTGFAXE9vhseLstrWI5J3wqL3yO5CF64",
  authDomain: "business.echomotion.ai",
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || "https://aideline-pro-default-rtdb.firebaseio.com",
  projectId: "aideline-pro",
  storageBucket: "aideline-pro.firebasestorage.app",
  messagingSenderId: "1075250029985",
  appId: "1:1075250029985:web:52ea5ed9c774d1b77d17e0",
  measurementId: "G-C3D83M8Z9N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1'); // Same region as Cloud Functions

// Check if we should use the emulator (disabled by default since Java is not installed)
const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';

if (useEmulator && !window._firebase_emulator_connected) {
  console.log('🔥 Connecting to Firebase Emulator Suite...');
  
  try {
    // Connect to Firestore Emulator
    connectFirestoreEmulator(db, 'localhost', 8082);
    
    // Connect to Auth Emulator
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    
    window._firebase_emulator_connected = true;
    console.log('✅ Connected to Firebase Emulators');
  } catch (error) {
    // If already connected, ignore the error
    if (!error.message?.includes('already been called')) {
      console.error('Failed to connect to emulators:', error);
    }
  }
} else {
  // Production mode - enable network
  console.log('🚀 Connected to Firebase Production (Project: aideline-pro)');
  enableNetwork(db).catch((error) => {
    console.warn('Firestore network enablement failed:', error);
    // Continue anyway - app should still work in offline mode
  });
}

// Initialize Analytics only if supported (avoid issues in development)
export let analytics: any = null;
isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
}).catch(console.error);

// Add type declaration for window
declare global {
  interface Window {
    _firebase_emulator_connected?: boolean;
  }
}

export default app;
